module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/help-to-buy-wales-c72d6ebd26a292f6ed95dc86886da54a.png";